import { render, staticRenderFns } from "./feetscare-satellite.vue?vue&type=template&id=56657152&scoped=true&"
import script from "./feetscare-satellite.vue?vue&type=script&lang=js&"
export * from "./feetscare-satellite.vue?vue&type=script&lang=js&"
import style0 from "./feetscare-satellite.vue?vue&type=style&index=0&id=56657152&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56657152",
  null
  
)

export default component.exports